import { render, staticRenderFns } from "./br-paginate.vue?vue&type=template&id=19fc5e17&scoped=true"
import script from "./br-paginate.vue?vue&type=script&lang=js"
export * from "./br-paginate.vue?vue&type=script&lang=js"
import style0 from "./br-paginate.vue?vue&type=style&index=0&id=19fc5e17&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fc5e17",
  null
  
)

export default component.exports